<div class="pagination-container">
  @if (currentPageIndex > 0) {
    <button class="pagination-button" (click)="showPageClick(currentPageIndex -1)" data-testid="prev-page"
    >{{"pagination-previous" | translate}}</button>
  }
  @if (showNext()) {
    <button class="pagination-button" (click)="showPageClick(currentPageIndex + 1)" data-testid="next-page"
    >{{"pagination-next" | translate}}</button>
  }
</div>
